export default __webpack_public_path__ + "static/media/tgs2026.55b7791c.png";